import { ApiQuery, ApiResponse, ConnectorDTO } from "@/@types";
import { Connector } from "@/domain/models";
import { Endpoints, Http, HttpService } from "@/infra/api";
import { ConnectorEntity } from "@/domain/entities";

interface ConnectorRepository {
  getConnectorTypes: (query?: ApiQuery) => Promise<ApiResponse<string[]>>;
  getConnector: (id: string) => Promise<ApiResponse<Connector>>;
  addConnector: (params: ConnectorDTO) => Promise<ApiResponse<Connector>>;
  updateConnector: (
    id: string,
    params: Partial<ConnectorDTO>
  ) => Promise<ApiResponse<Connector>>;
  removeConnector: (id: string) => Promise<ApiResponse<ConnectorEntity>>;
}

export const ConnectorService = (
  http: Http = HttpService()
): ConnectorRepository => ({
  getConnectorTypes: (query) => {
    return http.get<string[]>(Endpoints.connector_types, query);
  },
  getConnector: async (id) => {
    const res = await http.get<ConnectorEntity>(
      `${Endpoints.charger_connectors}/${id}`
    );
    const data = new Connector(res.data);
    return { ...res, data };
  },
  updateConnector: async (id, params) => {
    const res = await http.put<Partial<ConnectorDTO>, ConnectorEntity>(
      `${Endpoints.charger_connectors}/${id}`,
      params
    );
    const data = new Connector(res.data);
    return { ...res, data };
  },
  addConnector: async (params) => {
    const res = await http.post<ConnectorDTO, ConnectorEntity>(
      Endpoints.charger_connectors,
      params
    );
    const data = new Connector(res.data);
    return { ...res, data };
  },
  removeConnector: (id) => {
    return http.delete<ConnectorEntity>(
      `${Endpoints.charger_connectors}/${id}`
    );
  },
});
